import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const VideoPlayerSubtitlesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "VideoPlayerSubtitles",
    children: /*#__PURE__*/_jsx("path", {
      d: "M28.91 4.63H3.09c-.6 0-1.09.49-1.09 1.09v15.31c0 .6.49 1.09 1.09 1.09h6.34v4.86c0 .32.38.5.63.3l6.3-5.15H28.9c.6 0 1.09-.49 1.09-1.09V5.72c0-.6-.49-1.09-1.09-1.09ZM4.44 9.08c0-.19.16-.35.35-.35h7.18c.19 0 .35.16.35.35v1.49c0 .19-.16.35-.35.35H4.79c-.19 0-.35-.16-.35-.35zm13.59 6.93c0 .19-.16.35-.35.35H4.79c-.19 0-.35-.16-.35-.35v-1.49c0-.19.16-.35.35-.35h12.89c.19 0 .35.16.35.35zm9.53 0c0 .19-.16.35-.35.35h-7.17c-.19 0-.35-.16-.35-.35v-1.49c0-.19.16-.35.35-.35h7.18c.19 0 .35.16.35.35v1.49Zm0-5.44c0 .19-.16.35-.35.35H14.32c-.19 0-.35-.16-.35-.35V9.08c0-.19.16-.35.35-.35h12.89c.19 0 .35.16.35.35z"
    })
  }));
};